"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Root = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_ui_1 = require("@yanzi/react-ui");
const lodash_1 = require("lodash");
const react_1 = require("react");
const __1 = require("../..");
const globalTypes_1 = require("../../__types__/globalTypes");
const Asset_1 = require("./Asset");
function Root({ selection, onSelect, }) {
    const locationId = __1.useLocationId();
    const { data, loading } = __1.useTopLevelAssets(locationId);
    const assets = react_1.useMemo(() => {
        return lodash_1.orderBy(data !== null && data !== void 0 ? data : [], ['name']).filter(asset => asset.unitTypeFixed !== globalTypes_1.UnitType.physicalOrChassis);
    }, [data]);
    if (!assets) {
        return loading ? jsx_runtime_1.jsx(react_ui_1.BarLoader, {}, void 0) : null;
    }
    return (jsx_runtime_1.jsx(jsx_runtime_1.Fragment, { children: assets.map((asset, i) => {
            var _a, _b;
            return (jsx_runtime_1.jsx(Asset_1.Asset, { asset: asset, selection: selection, onSelect: onSelect }, (_b = (_a = asset.unitAddress) === null || _a === void 0 ? void 0 : _a.did) !== null && _b !== void 0 ? _b : i));
        }) }, void 0));
}
exports.Root = Root;
//# sourceMappingURL=Root.js.map